import React from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';

const RefillPlanConfirmModal = ({ isOpen, closeModal, message, t, onConfirm }) => {
    return (
        <Modal isOpen={isOpen} centered={true} size="lg">
            <ModalBody className="refillschema__modal refillschema__modal-request">
                <div className="refillschema__modal-info refillschema__modal-info--warn">
                    <svg>
                        <use xlinkHref="#icon-help-circle"></use>
                    </svg>
                    <div>{message}</div>
                </div>
            </ModalBody>
            <ModalFooter>
                <div className="refillschema__modal-btn" onClick={closeModal}>
                    {t('main:cancel')}
                </div>
                <div className="refillschema__modal-btn refillschema__modal-btn--confirm" onClick={onConfirm}>
                    {t('main:confirm')}
                </div>
            </ModalFooter>
        </Modal>
    );
};

export default RefillPlanConfirmModal;
